import moment from "moment";
import _ from "lodash";

export function formatNumberWithDots(number) {
  return (number || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function calculateTimeDifference(startTime, endTime) {
  const start = new Date(startTime);
  const end = new Date(endTime);

  // Tính sự khác biệt thời gian (milliseconds)
  const diffMs = end.getTime() - start.getTime();

  // Chuyển đổi sự khác biệt thời gian từ milliseconds thành phút và giờ
  const diffMins = Math.floor(diffMs / 1000 / 60);
  const hours = Math.floor(diffMins / 60);
  const minutes = diffMins % 60;

  // Tạo chuỗi kết quả
  return `${hours}g ${minutes}p`;
}

export function convertMinutesToHoursAndMinutes(minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}g ${remainingMinutes}p`;
}

export function getPriceAdd(prices, specificTime, flightType) {
  const pricesDomestic = _.filter(prices, {
    flightType: "domestic",
    isActive: true,
  });
  const pricesInternational = _.filter(prices, {
    flightType: "international",
    isActive: true,
  });
  const now = moment();
  const specificMoment = moment(specificTime);
  const diffInHours = specificMoment.diff(now, "hours");
  const diffInDays = specificMoment.diff(now, "days");
  const pricesList =
    flightType === "domestic" ? pricesDomestic : pricesInternational;
  const pricesHour = _.sortBy(
    _.filter(pricesList, { applyUnit: "HOUR" }),
    "thresholdValue"
  );
  const pricesDay = _.sortBy(
    _.filter(pricesList, { applyUnit: "DAY" }),
    "thresholdValue"
  );
  const pricesAll = _.filter(pricesList, { applyUnit: "ALL" });
  let price = {};
  price = _.find(pricesHour, (item) => item.thresholdValue >= diffInHours);
  if (!_.isEmpty(price)) return price;
  price = _.find(pricesDay, (item) => item.thresholdValue >= diffInDays);
  if (!_.isEmpty(price)) return price;
  price = pricesAll[0];
  if (!_.isEmpty(price)) {
    return price;
  } else {
    return {};
  }
}

export const getStatusDiv = (status, isOver15Minutes) => {
  if (!status) return;
  // Define status mappings
  const statusMap = {
    "Issued": { text: "Xuất vé thành công", bgColor: "bg-green-600" },
    "Success": { text: "Thanh toán thành công", bgColor: "bg-green-500" },
    "Refund": { text: "Hoàn tiền", bgColor: "bg-yellow-500" },
    "Fail": { text: "Thanh toán lỗi", bgColor: "bg-red-500" },
    "PayLater": { text: "Đặt vé", bgColor: "bg-yellow-500" },
  };

  // Find the appropriate status from the map
  const { text, bgColor } = statusMap[status] || {};

  // Return the div only if the status is valid
  if (text && bgColor) {
    return (
      <div
        className={`text-white ${bgColor} rounded-[20px] px-2 py-1 w-fit text-[10px]`}
      >
        {isOver15Minutes && status === "PayLater" ? "Hết hạn giữ chỗ" : text}
      </div>
    );
  }

  // Return a fallback if the status is invalid
  return (
    <div className="text-white bg-gray-400 rounded-[20px] px-4 py-1 w-fit text-[10px]">
      Không xác định
    </div>
  );
};

export const checkRepayment = (expirationdate) => {
  console.log(expirationdate,'expirationdate');
  
  const expirationDate = moment(expirationdate);
  const now = moment();
  return now.isBefore(expirationDate);
};
